<template>
  <div class="comment copy">
    <a-modal v-model="visible" title="添加评论" :maskClosable="false" :closable="false" on-ok="handleOk" >
      <div class="comment-item-content">
        <div class="comment-item">
          <i class="star">*</i>
          <p class="comment-label" style="margin-left: 8px">评论内容:</p>
          <a-textarea
            v-model="commentValue"
            placeholder="请输入..."
            :auto-size="{ minRows: 4, maxRows: 5 }"
          />
        </div>
        <div class="comment-item">
          <p class="comment-label">提醒谁关注:</p>
          <a-select
            mode="multiple"
            style="width: 100%"
            placeholder="请选择..."
            @change="handleSelectChange"
            v-if="init"
          >
            <a-select-option v-for="i in userList" :key="i.id">
              {{ i.name }}
            </a-select-option>
          </a-select>
          <a-checkbox :checked="checked" class="comment-tip" @change="onCheckChange">
            通过工作消息发送评论
          </a-checkbox>
        </div>
        <div class="comment-item">
          <p class="comment-label">附件:</p>
          <a-upload class="upload-list-inline" name="file" :remove="handleRemove" :beforeUpload="beforeUpload" accept=".png,.jpg,.jpeg,.ppt,.pptx,.pdf,.doc,.docx,.xls,.xlsx,.xlsm,.xltx,.xltm,.xlsb,.xlam" :multiple="true" :fileList="fileList" :defaultFileList="fileList" listType="picture">
            <a-button class="upload-btn" icon="upload">上传</a-button>
          </a-upload>
          <!-- <p class="comment-tip">支持扩展名: .png .jpg .ppt .pdf .doc .xls .xlsx...</p> -->
        </div>
      </div>
      <template slot="footer">
        <a-button key="back" @click="handleCancel()">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk()">
          确定
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import {
  uploadApi,
  getNoticeUserList,
  sendComment
} from "../services/CommonService.js";
export default {
  components: {},
  props: {
    visible: {
      default: false,
      type: Boolean
    },
    confirmLoading: Boolean
  },
  data() {
    return {
      fileList: [],
      init: true,
      loading: false,
      checked: true,
      commentValue: "",
      userList: [],
      notice_user_id: [],
      attachment: []
    };
  },
  methods: {
    handleOk() {
      if (!this.commentValue) {
        this.$Message.error("请填写评论内容!");
        return;
      }
      const params = {
        apply_id: this.$route.query.id,
        content: this.commentValue,
        notice_user_id: this.notice_user_id,
        attachment: this.attachment,
        send_ding_message: this.checked
      };

      sendComment(params).then(res => {
        if (res.status === "success") {
          this.$Message.success("评论成功");
          this.commentValue = "";
          this.attachment = [];
          this.fileList = [];
          this.notice_user_id = [];
          this.checked = true;
          this.init = false;
          setTimeout(() => {
            this.init = true;
          }, 500);
          this.$emit("reload");
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    handleCancel() {
      this.$emit("cancel");
    },

    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },

    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 <= 10;
      let hasSameNameFile = false;
      if (!isLt10M) {
        this.$Message.error("单文件不能大于 10MB！");
        return false;
      }
      this.fileList.forEach(item => {
        if (item.name === file.name) {
          hasSameNameFile = true;
          this.$Message.warning("该文件名与已上传文件名相同");
        }
      });
      if (isLt10M && !hasSameNameFile) {
        this.handleChange(file);
      }
      return false;
    },

    handleChange(file) {
      const fileInfo = new FormData();
      fileInfo.append("fileInfo", file);
      uploadApi(fileInfo).then(res => {
        if (res.status === "success") {
          file.file_key = res.data.annexKey;
          file.uid = res.data.annexKey;
          file.url = res.data.url;
          file.thumbUrl = this.checkIsImage(file.name)
            ? "/images/file-image.svg"
            : "/images/file-default.svg";
          this.fileList = [...this.fileList, file];
          this.attachment = this.setFileObj();
          this.$Message.success(`${file.name}上传成功！`);
        } else {
          this.$Message.error(res.message);
        }
      });
    },

    setFileObj() {
      let fileObj = [];
      fileObj = this.fileList.map(item => {
        return {
          id: item.file_key,
          name: item.name,
          url: item.url
        };
      });
      return fileObj;
    },

    checkIsImage(filepath) {
      const extStart = filepath.lastIndexOf(".");
      const ext = filepath.substring(extStart, filepath.length).toUpperCase();
      let isImage = false;
      if (
        ext != ".BMP" &&
        ext != ".PNG" &&
        ext != ".GIF" &&
        ext != ".JPG" &&
        ext != ".JPEG"
      ) {
        isImage = false;
      } else {
        isImage = true;
      }
      return isImage;
    },

    onCheckChange(e) {
      this.checked = e.target.checked;
    },

    // 获取可被艾特人员列表
    getNoticeUserList() {
      getNoticeUserList({ apply_id: this.$route.query.id }).then(res => {
        if (res.status == "success") {
          this.userList = res.data;
        }
      });
    },

    // 获取提醒人ID
    handleSelectChange(e) {
      this.notice_user_id = e;
    }
  },

  created() {
    this.getNoticeUserList();
  }
};
</script>

<style lang="less">
.comment-item-content {
  .comment-item {
    margin-bottom: 20px;
    position: relative;
    .star {
      position: absolute;
      left: -2px;
      top: 3px;
      color: red;
    }
    .comment-label {
      margin-bottom: 6px;
    }
    .comment-tip {
      margin-top: 6px;
    }
  }
}
</style>
